import { TargetGroupFilter } from '..';
import { AgeRanges, Genders } from '../models/target-group-filter';

export const emptyTargetGroupFilter: TargetGroupFilter = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  ages: [
    {
      age: AgeRanges.age_12_14,
      selected: true,
    },
    {
      age: AgeRanges.age_15_24,
      selected: true,
    },
    {
      age: AgeRanges.age_25_34,
      selected: true,
    },
    {
      age: AgeRanges.age_35_44,
      selected: true,
    },
    {
      age: AgeRanges.age_45_54,
      selected: true,
    },
    {
      age: AgeRanges.age_55_64,
      selected: true,
    },
    {
      age: AgeRanges.age_65_more,
      selected: true,
    },
  ],
  genders: [
    {
      gender: Genders.FEMALE,
      selected: true,
    },
    {
      gender: Genders.MALE,
      selected: true,
    },
  ],
};
